module.exports = __webpack_public_path__ + "static/media/Legacy-referrals.a0ab123b.png";